// extracted by mini-css-extract-plugin
export default {"state":"css_state__sVGau","icon":"css_icon__WYf-v","title":"css_title__3NamY","text":"css_text__ZnQoy"};